/**
 * Document title helpers (react-helmet-async convention).
 *
 * Every page sets its own <title> via <Helmet>. `pageTitle` centralizes the
 * "<segment> · FeedbackHub" suffix so all 25+ pages stay consistent, and
 * guards against rendering "undefined" or an empty leading segment while a
 * dynamic page (board, post, ...) is still loading or the entity is missing.
 */

export const APP_NAME = 'FeedbackHub';

export function pageTitle(segment?: string | null): string {
  const trimmed = segment?.trim();
  return trimmed ? `${trimmed} · ${APP_NAME}` : APP_NAME;
}
